import React, {Component} from "react";
import TimeframeSelection from "../../../components/common/TimeframeSelection";
import ProjectReports from "../../../components/Project/ProjectReports";
import {withTranslation} from 'react-i18next';
import ProjectStep2 from "./ProjectWizard";

class ProjectStep3 extends Component{
  render() {
    const {timeFilter, handleTimeFilterUpdate, projects, handleProjectReportsUpdate,selectAllHandler,isSelectAllChecked, resetSelectAllCheckStatus,absoluteStartError, absoluteEndError, benchmarkError, t} = this.props;
    return(
      <div className="wizard-step project-wizard-step-main-content">
        <h5 className="text-center wizard-subtitle">{t('project:historicalTitle')}</h5>
        <TimeframeSelection
          filterType="Historical"
          timeFilter={timeFilter}
          handleTimeFilterUpdate={handleTimeFilterUpdate}
          context={'project'}
          absoluteStartError={absoluteStartError}
          absoluteEndError={absoluteEndError}
          benchmarkError={benchmarkError}
        />
        <ProjectReports
          reportType="HISTORICAL"
          projects={projects}
          handleProjectReportsUpdate={handleProjectReportsUpdate}
          selectAllHandler={selectAllHandler}
          isSelectAllChecked ={isSelectAllChecked}
          resetSelectAllCheckStatus={resetSelectAllCheckStatus}
          trans={t}
        />
      </div>
    )
  }
}

export default withTranslation()(ProjectStep3);